export const DEFAULT_REQUEST_TIMEOUT_MS = 1;
export const INVALID_AXIOS_CONFIG_ERROR_MESSAGE = 'Invalid AxiosRequestConfig: Required fields are missing.';
export const SEARCH_PERSEUS_CLIENT_NAME = 'search_perseus_client';
